'use client';

import { createWithEqualityFn } from 'zustand/traditional';
import { shallow } from 'zustand/shallow';
import { persist, createJSONStorage } from 'zustand/middleware';
import { applyDevtools, safeCookieStorage } from './storeUtils';
import { config } from '@/config';

interface AuthSessionState {
    isLoggedIn: boolean;
}

const initialState: AuthSessionState = {
    isLoggedIn: false,
};

export const useAuthSessionStore = createWithEqualityFn<AuthSessionState>()(
    persist(
        applyDevtools(() => initialState, { name: `MPW ${config.theme} Auth Session Store` }),
        {
            name: `mpw-${config.theme}-auth-cookie-storage`,
            storage: createJSONStorage(() => safeCookieStorage),
        },
    ),
    shallow,
);
